module.exports = __webpack_public_path__ + "media/testimonials/property-7-dac8447f.jpg";